import(/* webpackMode: "eager" */ "/vercel/path0/src/app/auth/signup/student/page.tsx");
